// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  Tag,
  Violation,
  SeriousOffenseReason,
  UpdateFormValues,
  Suggestion,
  UsersCharacteristic,
} from "pages/ControlCenter/ContentManagement/contentManagementUtils/tabSchema";
import { getApiSLice } from "utils/getApiBaseQuery";
import { DBEntityNameCodes } from "features/api/constants/enums";
import { DBRejectionReason } from "models/RejectionReason";

export const contentManagementApiSliceDev = getApiSLice("dev").injectEndpoints({
  endpoints: (builder) => ({
    getTagList: builder.query<Tag[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.Tags}`,
        method: "GET",
      }),
      providesTags: ["Tags"],
    }),
    addOrUpdateTag: builder.mutation({
      query: (newTag: Tag[]) => ({
        url: "/tags/AddOrUpdateTag",
        method: "POST",
        body: newTag,
      }),
      invalidatesTags: ["Tags"],
    }),
    getViolationsList: builder.query<Violation[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.OffenseType}`,
        method: "GET",
      }),
      providesTags: ["Violations"],
    }),
    addOrUpdateViolations: builder.mutation({
      query: (newViolation: {
        offenceTypeCode: number;
        offenceName: string;
        policyDecision: string;
        decision: string;
        Disable?: boolean;
      }) => ({
        url: "/collections/AddOrUpdateOffenseType",
        method: "POST",
        body: newViolation,
      }),
      invalidatesTags: ["Violations"],
    }),
    getDecisionTypesList: builder.query<{ id: number; name: string }[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.DecisionType}`,
        method: "GET",
      }),
      providesTags: ["Decisions"],
    }),
    getSeriousOffenseReasonsList: builder.query<SeriousOffenseReason[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.SeriousOffenseReasonsType}`,
        method: "GET",
      }),
      providesTags: ["SeriousOffenseReasons"],
    }),
    addOrUpdateSeriousOffenseReason: builder.mutation({
      query: (newReason: { name: string; id: number; disable: boolean }) => ({
        url: "/collections/AddOrUpdateSeriousOffenseReasonsType",
        method: "POST",
        body: newReason,
      }),
      invalidatesTags: ["SeriousOffenseReasons"],
    }),
    getRejectionReasonsList: builder.query<DBRejectionReason[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.RejectionReasonType}`,
        method: "GET",
      }),
      providesTags: ["RejectionReasons"],
    }),
    addOrUpdateRejectionReason: builder.mutation({
      query: (newReason: { ID: number; Name: string; Disable: boolean }) => ({
        url: "/collections/AddOrUpdateRejectionReasonsType",
        method: "POST",
        body: newReason,
      }),
      invalidatesTags: ["RejectionReasons"],
    }),
    getManagedUpdatesList: builder.query<UpdateFormValues[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.ManagedUpdates}`,
        method: "GET",
      }),
      providesTags: ["ManagedUpdates"],
    }),
    addOrUpdateManagedUpdate: builder.mutation({
      query: (data: UpdateFormValues) => ({
        url: "/collections/AddOrUpdateManagedUpdate",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ManagedUpdates"],
    }),
    getExampleFile: builder.query<Blob, void>({
      query: () => ({
        url: `/collections/GetManagedUpdateExcelExample`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    getSuggestionList: builder.query<Suggestion[], void>({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.Suggestions}`,
        method: "GET",
      }),
      providesTags: ["Suggestions"],
    }),

    addOrUpdateSuggestion: builder.mutation({
      query: (payload) => ({
        url: "/suggestions",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Suggestions"],
    }),
    useGetSuggestionListQuery: builder.query({
      query: () => "/backOffice/SaveSuggestion",
      providesTags: ["Suggestions"],
    }),
    getUsersCharacteristicList: builder.query<UsersCharacteristic[]>({
      query: () => ({
        url: `/collections/GetUsersCharacteristicList`,
        method: "GET",
      }),
      providesTags: ["UsersCharacteristics"],
    }),
    addOrUpdateUsersCharacteristic: builder.mutation({
      query: (newUsersCharacteristic: {
        id: number;
        name: string;
        disable: boolean;
      }) => ({
        url: `/collections/AddOrUpdateUsersCharacteristic`,
        method: "POST",
        body: newUsersCharacteristic,
      }),
      invalidatesTags: ["UsersCharacteristics"],
    }),
  }),
});

export const {
  useGetTagListQuery,
  useAddOrUpdateTagMutation,
  useGetViolationsListQuery,
  useAddOrUpdateViolationsMutation,
  useGetDecisionTypesListQuery,
  useGetSeriousOffenseReasonsListQuery,
  useAddOrUpdateSeriousOffenseReasonMutation,
  useGetRejectionReasonsListQuery,
  useAddOrUpdateRejectionReasonMutation,
  useGetManagedUpdatesListQuery,
  useAddOrUpdateManagedUpdateMutation,
  useGetExampleFileQuery,
  useGetSuggestionListQuery,
  useAddOrUpdateSuggestionMutation,
  useGetUsersCharacteristicListQuery,
  useAddOrUpdateUsersCharacteristicMutation,
} = contentManagementApiSliceDev;
